import React from 'react';
import FAQ from '../../.shared/FAQ/FAQ';

const CEO_FAQ_ITEMS = [
    {
        question: 'Is compounded semaglutide FDA-approved?',
        answer: 'Compounded medications are not FDA-approved, not evaluated for safety or efficacy, and not equivalent to brand-name versions. They are prescribed when clinically appropriate by a licensed clinician.',
    },
    {
        question: 'Why did Paul Moss start TB2 Health?',
        answer: 'Paul spent his 30s roughly 90 lbs overweight. After GLP-1 medications helped him lose the weight, he saw that misinformation was keeping many people from accessing something that could genuinely help them. TB2 Health was built to cut through the noise with education-first, clinician-led care.',
    },
    {
        question: 'How does the intake process work?',
        answer: 'It\'s asynchronous — like texting your clinician. Complete your intake form from your phone in about 5 minutes. A licensed clinician reviews your information within 24 hours. No waiting rooms, no awkward calls.',
    },
    {
        question: 'What happens after I finish the program?',
        answer: 'TB2 Health offers long-term metabolic and cardiovascular support programs for after your GLP-1 course. The goal isn\'t just weight loss — it\'s repairing the metabolic and cardiovascular effects of excess weight over time.',
    },
    {
        question: 'How does billing work?',
        answer: 'Subscription renews monthly unless canceled. Future charges are disclosed before purchase. Full refund if not prescribed; additional cases handled per policy.',
    },
    {
        question: 'Who prescribes and dispenses?',
        answer: 'TB2 Health facilitates care. Clinicians prescribe independently. State-licensed pharmacies dispense medications. Every prescription is clinically evaluated — not just approved automatically.',
    },
];

const CEO_FAQ_DESCRIPTION = "Everything you need to know about GLP-1s, how TB2 Health works, billing, and what's included — from people who've been through it themselves.";

function CEOFAQ() {
    return <FAQ items={CEO_FAQ_ITEMS} description={CEO_FAQ_DESCRIPTION} />;
}

export default CEOFAQ;
